export default {
  title: 'Sei sicuro di voler eliminare il tuo account?',
  description:
    "Questa azione è definitiva. Perderai l'accesso ai tuoi ordini, ai punti fedeltà e alle preferenze salvate.",
  labels: {
    loading: 'Eliminazione account in corso...',
  },
  buttons: {
    confirm: 'Conferma',
    cancel: 'Annulla',
  },
  toasts: {
    success:
      'Il tuo account è stato eliminato definitivamente. Non hai più accesso alla cronologia degli ordini, ai punti fedeltà o ai dati salvati.',
    error: 'Qualcosa è andato storto. Riprova. Se il problema persiste, contatta il nostro supporto: {{supportEmail}}',
  },
};
